import { useTheme } from '@mui/material/styles';

type FormBuilderErrorMessageProps = {
  error?: {
    message?: string;
  };
};

export default function FormBuilderErrorMessage({
  error,
}: Readonly<FormBuilderErrorMessageProps>) {
  const theme = useTheme();

  const message = error?.message ? error.message : 'Required Field';
  return (
    <p
      aria-invalid="true"
      aria-errormessage={message}
      style={{
        color: theme.palette.error.main,
        fontSize: '0.875rem',
        marginTop: '.3rem',
      }}
    >
      {message}
    </p>
  );
}
